import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import CustomizedTable from "../../CustomizedTable/CustomizedTable";
import { DefaultCell, UpCaseCell } from "../../CustomizedTable/CustomCells/CustomCells";
import CarrierNameCell from "../../CustomizedTable/CustomCells/CarrierNameCell/CarrierNameCell";
import MilesCell from "../../CustomizedTable/CustomCells/MilesCell/MilesCell";
import MultiOptionsFilter from "../../CustomizedTable/Filters/MultipleOptionsFilter/MultipleOptionsFilter";
import NumberRangeFilter from "../../CustomizedTable/Filters/NumberRangeFilter/NumberRangeFilter";
import SelectColumnFilter from "../../CustomizedTable/Filters/SelectColumnFilter/SelectColumnFilter";

export default function CarrierSearchHomeLocation({
  isLoading,
  search,
  homeLocationResults,
  handleTableAction
}) {
  const results = useMemo(() => homeLocationResults, [homeLocationResults]);

  const columns = useMemo(
    () => [
      {
        Header: "Carrier Status",
        accessor: "active",
        Filter: SelectColumnFilter,
        filter: "equal",
        width: 140,
        Cell: DefaultCell
      },
      {
        Header: "Carrier",
        accessor: "carrierName",
        filter: "fuzzyText",
        width: 240,
        idKey: "carrierId",
        Cell: CarrierNameCell,
      },
      {
        Header: "MC",
        accessor: "mcNumber",
        filter: "fuzzyText",
        width: 100,
        Cell: DefaultCell,
      },
      {
        Header: "Home Location",
        accessor: "carrierHomeCity",
        filter: "fuzzyText",
        width: 160,
        Cell: UpCaseCell,
      },
      {
        Header: "HS",
        accessor: "carrierHomeState",
        Filter: MultiOptionsFilter,
        filter: "multi",
        width: 80,
        Cell: DefaultCell,
      },
      {
        Header: "Home Loc Radius",
        accessor: "milesOriginHomeLoc",
        Filter: NumberRangeFilter,
        filter: "between",
        width: 160,
        Cell: MilesCell,
      },
      {
        Header: "Carrier Mgr",
        accessor: "carrierMgr",
        filter: "fuzzyText",
        width: 130,
        Cell: DefaultCell,
      },
      {
        Header: "Tractors",
        accessor: "totalTractors",
        Filter: NumberRangeFilter,
        filter: "between",
        width: 100,
        Cell: DefaultCell,
      },
      {
        Header: "Trailers",
        accessor: "totalTrailers",
        Filter: NumberRangeFilter,
        filter: "between",
        width: 100,
        Cell: DefaultCell,
      },
      {
        Header: "Equipment Types",
        accessor: "equipmentTypeId",
        Filter: SelectColumnFilter,
        filter: "equal",
        width: 160,
        Cell: DefaultCell
      },
    ],
    []
  );

  return (
    <Box>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <CircularProgress sx={{ color: "primary.60" }} size={40} />
        </Box>
      ) : (
        <CustomizedTable
          id="home-location-search"
          columns={columns}
          data={results}
          tableSearch={search}
          actionCallback={handleTableAction}
        />
      )}
    </Box>
  );
}

CarrierSearchHomeLocation.propTypes = {
  isLoading: PropTypes.bool,
  search: PropTypes.string,
  homeLocationResults: PropTypes.array.isRequired,
  handleTableAction: PropTypes.func
};
